
import React, { useEffect, useMemo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FcPaid } from "react-icons/fc";
import ProductCard from "./productCard";
import "../css/weekdeal.css";
import CountdownTimer from "./sevenDayesTimer";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts, selectProducts } from "../redux/productSlice"; // Adjust the path as needed
import Slider from "react-slick";
import '../css/sliderCustom.css';

const WeekDeal = () => {
  const dispatch = useDispatch();
  const products = useSelector(selectProducts);

  // useEffect(() => {
  //   dispatch(fetchProducts());
  // }, [dispatch]);

  // Filter weeksdeal based on your criteria, e.g., discount
 
  const weeksdeal = useMemo(() => products.filter(product => product.discount).slice(0, 4))
  // weeksdeal.forEach((product, index) => {
  //   console.log(`Product ${index + 1}:`, product);
  // });
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 376,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <>
      <section className="title-weekdeal title-section mt-5">
        <Container>
          <Row>
            <Col md={12}>
              <div className="text-center d-flex align-items-center justify-content-center flex-column">
                <h2>THIS WEEK'S DEALS</h2>
                <p>
                  <FcPaid />
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="mt-5 weekdeal">
        <div className="weekdealBgImage">
          <img src="../imgs/weekdeal/1.jpg" />
        </div>
        <Container className="mainProductCartRow">
          <Row>
            <Slider {...settings}>
              {weeksdeal.map((product, index) => (
                <ProductCard key={index} product={product} />
              ))}
            </Slider>
            <br />
          </Row>
          <Row>
            <Col md={6}>
              <CountdownTimer />
            </Col>
            <Col md={6}>
              <button className="btn btn-primary weekdealbuttonshow">See More</button>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default WeekDeal;
